import React from 'react';
import { connect } from 'react-redux';
import { BackButton } from '../../../common/components';
import InternalContainer from '../../layout/containers/Internal';
import organisationSchema from '../../../schemas/organisation';
import OrganisationForm from '../components/OrganisationForm/OrganisationForm';
import { createOrganisation } from '../redux/organisationActions';

const OrganisationCreateContainer = ({
  onCreateOrganisation,
  location: {
    query: { organisationType },
  },
}) => {
  const create = (values) => {
    onCreateOrganisation(values);
  };

  const resource = {
    ...organisationSchema,
    data: {
      attributes: {
        ...organisationSchema.data.attributes,
      },
      relationships: {
        ...organisationSchema.data.relationships,
        organisation_type: {
          data: {
            id: organisationType,
          },
        },
      },
    },
  };

  return (
    <InternalContainer title="Organisation" buttons={<BackButton />}>
      <OrganisationForm
        resource={resource}
        organisationType={organisationType}
        onSave={create}
      />
    </InternalContainer>
  );
};

export default connect(
  null,
  {
    onCreateOrganisation: createOrganisation,
  },
)(OrganisationCreateContainer);
